export const sfUploaderOrigin = {
  label: 'NotesAndAttachments',
  name: 'ContentVersion',
  type: 'uploader',
}